import { useCallback, useMemo, useState } from 'react';

type useOpenModalProps = {
  onClosePostCallback?: (() => void) | undefined;
};

export const useOpenModal = (args?: useOpenModalProps | undefined) => {
  const [open, setOpen] = useState(false);
  const { onClosePostCallback } = args ?? {};

  const onClose = useCallback(() => {
    setOpen(false);
    onClosePostCallback?.();
  }, [onClosePostCallback]);

  const handleOpenModal = useCallback(() => {
    setOpen(true);
  }, []);

  return useMemo(() => ({ open, onClose, handleOpenModal }), [open, onClose, handleOpenModal]);
};
